import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import OneDriveProScope from 'owa-service/lib/contract/OneDriveProScope';
import { OneDriveProItemsSkipTokenPagingMetadata } from '../types/OneDriveProItemsSkipTokenPagingMetadata';
import { OneDriveProItemsSkipTokenPagingMetadataType, OneDriveProScopeName } from '../constants';

export function isOneDriveProScope(
    scope: AttachmentDataProviderScope | null
): scope is OneDriveProScope {
    return scope !== null && scope.__type === OneDriveProScopeName;
}

export function isOneDriveProItemsSkipTokenPagingMetadata(
    pagingMetadata: AttachmentItemsPagingMetadata
): pagingMetadata is OneDriveProItemsSkipTokenPagingMetadata {
    return pagingMetadata && pagingMetadata.__type === OneDriveProItemsSkipTokenPagingMetadataType;
}
